export const yodaCatalogueConstants = {
  GETONE_REQUEST: "YODACATALOGUE_GETONE_REQUEST",
  GETONE_SUCCESS: "YODACATALOGUE_GETONE_SUCCESS",
  GETONE_FAILURE: "YODACATALOGUE_GETONE_FAILURE",

  GETONESWAP_REQUEST: "YODACATALOGUE_GETONESWAP_REQUEST",
  GETONESWAP_SUCCESS: "YODACATALOGUE_GETONESWAP_SUCCESS",
  GETONESWAP_FAILURE: "YODACATALOGUE_GETONESWAP_FAILURE",

  GETONE_CATALOG_REQUEST: "YODACATALOGUE_GETONE_CATALOG_REQUEST",
  GETONE_CATALOG_SUCCESS: "YODACATALOGUE_GETONE_CATALOG_SUCCESS",
  GETONE_CATALOG_FAILURE: "YODACATALOGUE_GETALL_CATALOG_FAILURE",

  GETONESWAP_CATALOG_REQUEST: "YODACATALOGUE_GETONESWAP_CATALOG_REQUEST",
  GETONESWAP_CATALOG_SUCCESS: "YODACATALOGUE_GETONESWAP_CATALOG_SUCCESS",
  GETONESWAP_CATALOG_FAILURE: "YODACATALOGUE_GETALLSWAP_CATALOG_FAILURE",

  GETALL_REQUEST: "YODACATALOGUE_GETALL_REQUEST",
  GETALL_SUCCESS: "YODACATALOGUE_GETALL_SUCCESS",
  GETALL_FAILURE: "YODACATALOGUE_GETALL_FAILURE",

  GETALLSWAP_REQUEST: "YODACATALOGUE_GETALLSWAP_REQUEST",
  GETALLSWAP_SUCCESS: "YODACATALOGUE_GETALLSWAP_SUCCESS",
  GETALLSWAP_FAILURE: "YODACATALOGUE_GETALLSWAP_FAILURE",

  ADDALL_REQUEST: "YODACATALOGUE_ADDALL_REQUEST",
  ADDALL_SUCCESS: "YODACATALOGUE_ADDALL_SUCCESS",
  ADDALL_FAILURE: "YODACATALOGUE_ADDALL_FAILURE",

  ADDALLSWAP_REQUEST: "YODACATALOGUE_ADDALLSWAP_REQUEST",
  ADDALLSWAP_SUCCESS: "YODACATALOGUE_ADDALLSWAP_SUCCESS",
  ADDALLSWAP_FAILURE: "YODACATALOGUE_ADDALLSWAP_FAILURE",

  UPDATE_FILTERS: "YODACATALOGUE_GETFILTERS_SUCCESS",

  CLEAR_ORDER_CATALOG: "YODACATALOGUE_CLEAR_ORDER_CATALOG",
  CLEAR_SWAP_ITEMS: "YODACATALOGUE_CLEAR_SWAP_ITEMS",

  SEND_LOG: "SEND_LOG",
};
